import { useState, useRef } from "react";

export const useSignature = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPosition, setSelectedPosition] = useState(null);
  const [signaturePositions, setSignaturePositions] = useState([]);
  const signatureRef = useRef(null);

  const clearSignature = () => {
    signatureRef.current.clear();
  };

  const uploadFile = async (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.readAsDataURL(file);
    });
  };

  const saveSignature = async () => {
    if (!signatureRef.current || !selectedPosition) return;

    const url = signatureRef.current.toDataURL("image/png", {
      backgroundColor: "transparent",
    });
    const timestamp = new Date().toLocaleString();

    let updatedPositions = [];

    if (selectedPosition === "UPLOAD_ALL") {
      updatedPositions = signaturePositions.map((pos) => {
        return { ...pos, signature: url, timestamp };
      });
    } else {
      updatedPositions = signaturePositions.map((pos) =>
        pos === selectedPosition ? { ...pos, signature: url, timestamp } : pos
      );
    }

    setSignaturePositions(updatedPositions);
    setIsModalOpen(false);
    setSelectedPosition(null);
  };

  const handleSignatureUpload = async (file) => {
    if (!file || !selectedPosition) return;

    const url = await uploadFile(file);
    const timestamp = new Date().toLocaleString();

    let updatedPositions = [];

    if (selectedPosition === "UPLOAD_ALL") {
      updatedPositions = signaturePositions.map((pos) => {
        return { ...pos, signature: url, timestamp };
      });
    } else {
      updatedPositions = signaturePositions.map((pos) =>
        pos === selectedPosition ? { ...pos, signature: url, timestamp } : pos
      );
    }

    setSignaturePositions(updatedPositions);
    setIsModalOpen(false);
    setSelectedPosition(null);
  };

  return {
    isModalOpen,
    setIsModalOpen,
    selectedPosition,
    setSelectedPosition,
    signatureRef,
    clearSignature,
    saveSignature,
    handleSignatureUpload,
    setSignaturePositions,
    signaturePositions,
  };
};
